import React from 'react'
import './footer.css'
import MFLogo from '../../assets/nav-icons/kfin-logo.svg'
import { Link } from 'react-router-dom'
import openURL from '../../utils/helpers/openURL'

const Footer: React.FunctionComponent<any> = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mf-footer">
        <div className="mf-footer-container pt-5">
            <h2 className='text-capitalize weight-700 '>Contact <span>us</span></h2>
            {/* <Link to={'mailto:support@kfintech.com'} className='mb-0 mf-footer-support weight-400 no-text-decoration d-block'>support@kfintech.com</Link> */}
            <Link to={'mailto:finfabrik.support@kfintech.com'} className='mb-0 mf-footer-support weight-400 no-text-decoration d-block'>finfabrik.support@kfintech.com</Link>
            
            <img className='mf-footer-img mt-4 mb-1' width="230" height="80" src={MFLogo} alt="kfintech logo" />
            
            <div className="mf-footer-others row no-negative-margin align-items-center justify-content-between py-3">
                <p className="mb-0 col-12 col-md-4 col-lg-4 px-0 text-white weight-400 font-14 text-center text-md-start text-lg-start">© {currentYear} KFintech. All rights reserved.</p>
                <div className="col-12 col-md-4 col-lg-4 px-0 text-center my-3 my-md-0 my-lg-0">
                    <button onClick={() => openURL('/terms-of-use', 'open')} type='button' className="border-0 bg-transparent text-white text-capitalize weight-400 font-14 no-text-decoration me-3">Terms of use</button>
                    <button onClick={() => openURL('/privacy-policy', 'open')} type='button' className="border-0 bg-transparent text-white text-capitalize weight-400 font-14 no-text-decoration">Privacy Policy</button>
                </div>
                <p className="mb-0 col-12 col-md-4 col-lg-4 px-0 text-capitalize weight-300 text-white font-14 text-center text-md-end text-lg-end site-designedby">Site designed by <strong className='weight-500'>KFintech</strong></p>
            </div>

        </div>
    </footer>
  )
}

export default Footer